import { Button, type ButtonProps } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useDeleteMaster, type DeleteMasterArgs } from '../../hooks/useDeleteMaster.js';
import { confirmDeleteMaster } from './DeleteMasterConfirm.js';

/**
 * **Delete master**, asked first — the one control the drawer header and the editor header both
 * carry. What happens after the delete (close the drawer, leave the editor) is the host's
 * `args.onDeleted`.
 */
export const DeleteMasterButton = ({ args, size }: { args: DeleteMasterArgs; size?: ButtonProps['size'] }) => {
    const remove = useDeleteMaster();
    return (
        <Button
            size={size}
            variant="subtle"
            color="red"
            leftSection={<IconTrash size={14} stroke={1.7} />}
            loading={remove.isPending}
            onClick={() => confirmDeleteMaster(args, () => remove.run(args))}
        >
            Delete master
        </Button>
    );
};
